import type { CreditCardOffer } from '@cc-shopping/contracts/compare/schema/types';
import {
  SEGMENT_SKU_VIEWED_LEVEL,
  SEGMENT_SKU_VIEWED_PRODUCT_TYPE,
  SEGMENT_SKU_VIEWED_SOURCE,
} from '@cc-shopping/platform-analytics/lib/constants';
import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import type { CardOfferButtonWithAnalytics } from '../HorizontalScrollableCardList';

export const createOfferButton = (
  creditCardOffer: CreditCardOffer,
  section: string,
  position: number,
): CardOfferButtonWithAnalytics => {
  const {
    id,
    name,
    imageOptions: { resizable, large },
    institution: { id: institutionId, name: institutionName },
    product: { id: productId, name: productName },
  } = creditCardOffer;
  const { optimized } = customImageWidthURLBuilder(
    resizable,
    {
      customImageWidth: 300,
      customImageQuality: 100,
      imageParentWidth: 106,
    },
    large.url,
  );
  return {
    name,
    imageUrl: optimized.image.url,
    id,
    segmentAnalytics: {
      id,
      name,
      impressionSection: section,
      impressionPosition: position,
      institutionId,
      institutionName,
      level: SEGMENT_SKU_VIEWED_LEVEL,
      monetizable: 'no',
      offerId: id,
      offerName: name,
      productId,
      productName,
      productType: SEGMENT_SKU_VIEWED_PRODUCT_TYPE,
      source: SEGMENT_SKU_VIEWED_SOURCE,
    },
  };
};
